import React from 'react';
import { Box, Carousel } from '@drone-js/core';
import ReviewCardHeader from 'component/page/detail/Review/ReviewCard/ReviewCardHeader';
import ReviewCardTitle from 'component/page/detail/Review/ReviewCard/ReviewCardTitle';
import TextToggler from 'component/common/TextToggler/TextToggler';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesReviewCardImageSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesReviewCardImageSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { ReviewCardProps } from 'component/page/detail/Review/Review.selectors';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

interface Props {
    review: ReviewCardProps;
    currentIndex?: number;
}
const ReviewModalGallery: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    React.useEffect(() => {
        trackElementEvent<ActivitiesReviewCardImageSeenEventActivitiesFieldsV1>(
            ActivitiesReviewCardImageSeenEventActivitiesManifestV1.ids,
            {
                is_modal: true,
            },
            { action_element_value: props.review.id.toString() },
        );
    }, [props.review.id]);

    if (!props.review) return null;
    const review = props.review;

    return (
        <>
            <Carousel
                data-element-name="activities-review-modal-gallery"
                data-testid="activities-review-modal-gallery"
                display="single"
                pageButtons="inside"
                pageControl="bottom"
                pageCount="bottom-end"
                accessibilityLabel={cms[276248]}
                accessibilityPreviousNavLabel={cms[130765]}
                accessibilityNextNavLabel={cms[130706]}
                accessibilityPageNumberLabel={cms[152705]}
                currentCard={props.currentIndex || 0}
            >
                {review.media.map((item, index) => (
                    <Box key={index} pt="8">
                        <ActivityImage src={item.source} maxHeight="40vh" objectFit="contain" alt={item.description} />
                    </Box>
                ))}
            </Carousel>
            <Box p="24" data-testid="activities-review-modal-info">
                <ReviewCardHeader authorName={review.authorName} reviewDate={review.date} reviewSource={review.source} />
                <ReviewCardTitle reviewTitle={review.title} reviewScore={review.score} reviewSource={review.source} />
                <TextToggler text={review.description} defaultExpanded={false} isModal={true} />
            </Box>
        </>
    );
};

ReviewModalGallery.displayName = 'ReviewModalGallery';
export default ReviewModalGallery;
